import * as React from 'react';

import * as styles from './styles.css';

export const PageLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
